import { render, staticRenderFns } from "./PopularCompanies.vue?vue&type=template&id=020fea48&scoped=true"
import script from "./PopularCompanies.vue?vue&type=script&lang=ts"
export * from "./PopularCompanies.vue?vue&type=script&lang=ts"
import style0 from "./PopularCompanies.vue?vue&type=style&index=0&id=020fea48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020fea48",
  null
  
)

export default component.exports